export default {
  LimitExceededException: 'LimitExceededException',
  CodeMismatchException: 'CodeMismatchException',
  ExpiredCodeException: 'ExpiredCodeException',
  InvalidPasswordException: 'InvalidPasswordException',
};
